import type { BlockVisualProps } from '../../Types'
import type { DividerBlock } from '@/types/blocks/document/Divider'
import './divider-visual.css'
import React from 'react'

export function DividerVisual({ block }: BlockVisualProps) {
	if (block.type !== 'divider') return null

	const dividerBlock = block as DividerBlock
	const { style = 'solid', thickness = 1, color } = dividerBlock.properties

	// User-configurable styles
	const inlineStyle: React.CSSProperties = {
		borderTopWidth: `${thickness}px`,
	}
	if (color) inlineStyle.borderTopColor = color

	return (
		<hr
			className={`divider-visual divider-visual--${style}`}
			style={inlineStyle}
			role="separator"
			data-block-id={dividerBlock.id}
		/>
	)
}
